import { getScore } from '../common/scoreHelpers';
import { MergeRequest } from '@internal/backstage-plugin-renovate-stats';
import { sortSimpleScore } from '../common/sortScoreHelpers';
import { Team } from '@internal/schemas-common';
import { useMemo } from 'react';
import {
  getRenovateScore,
  useGetMergeRequests,
} from '@internal/backstage-plugin-renovate-stats';
import { ScoreIndex, SimpleScore } from '@internal/ui-common';

type UseGetScoresProps = {
  teams: Team[];
};

type UseGetScoresResult = {
  scores: ScoreIndex<SimpleScore>[] | undefined;
};

function getTeamFromMR(mr: MergeRequest): string {
  for (let i = 0; i < mr.labels.length; i++) {
    if (mr.labels[i].startsWith('renovate-bot-')) {
      return mr.labels[i].replace('renovate-bot-', '').replace('-ui', '');
    }
  }
  return 'error';
}

export const useGetRenovateScores = ({teams}: UseGetScoresProps): UseGetScoresResult => {
  const { value: mrs, loading } = useGetMergeRequests({ teams: teams });

  const scores = useMemo(() => {
    return getScore<MergeRequest, SimpleScore>(loading, teams, mrs, {
      getTeam: getTeamFromMR,
      getScore: getRenovateScore,
      sortScore: sortSimpleScore,
    });
  }, [mrs, teams, loading]);

  return { scores };
};
